'use client';

import { Download } from '@drift-labs/icons';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';
import useIsMainnet from 'src/hooks/useIsMainnet';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import useModal from 'src/components/Modals/hooks/useModal';
import { ExportHistoryModalProps } from 'src/components/Modals/ExportHistoryModal/ExportHistoryModal';
import Button from 'src/components/primitives/Button/Button';
import { WithClassName } from 'src/utils/UtilityTypes';

export default function ExportHistoryButton({
	type,
	className,
}: WithClassName<ExportHistoryModalProps>) {
	const connected = useWalletIsConnected();
	const isMainnet = useIsMainnet();
	const hasDeletedAccounts = useDriftAccountStore(
		(s) => (s.deletedAccounts?.length ?? 0) > 0
	);
	const { show } = useModal();

	const showExportHistoryModal = () => {
		show({ type: 'export_history', props: { type } });
	};

	return (
		<Button
			size="md"
			variant="secondary"
			className={className}
			rightIcon={Download}
			onClick={showExportHistoryModal}
			disabled={!isMainnet || (!connected && !hasDeletedAccounts)}
		>
			Export
		</Button>
	);
}
